import { createSlice } from '@reduxjs/toolkit';

interface IAIConversationState {
  areChangesLoading: boolean;
}

const initialState: IAIConversationState = {
  areChangesLoading: false,
};

const aiConversationSectionsSlice = createSlice({
  name: 'aiConversationSections',
  initialState,
  reducers: {},
});

export default aiConversationSectionsSlice.reducer;
